export const PDF_PAGE_WIDTH_PT = 612;
export const PDF_PAGE_HORIZONTAL_PADDING_PT = 56;
export const PDF_CONTENT_WIDTH_PT = PDF_PAGE_WIDTH_PT - PDF_PAGE_HORIZONTAL_PADDING_PT * 2;
export const PDF_MAX_IMAGE_HEIGHT_PT = 260;
export const PDF_IMAGE_DPI_SCALE = 72 / 96;
export const PDF_IMAGE_DIMENSION_TIMEOUT_MS = 10_000;
